import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ExamAgencyHttpService {
  private BASE_URL = environment.apiBaseUrl;
  constructor(private readonly httpClient: HttpClient) {}

  getExamAgencyList<T>(loggedInUserID: string) {
    return this.httpClient.get<T>(
      `${this.BASE_URL}api/GetExamAgency?LoggedInUserId=${loggedInUserID}&ExamAgencyId=`
    );
  }

  getExamAgencyById<T>(loggedInUserID: string, examAgencyId: string) {
    return this.httpClient.get<T>(
      `${this.BASE_URL}api/GetExamAgency?LoggedInUserId=${loggedInUserID}&ExamAgencyId=${examAgencyId}`
    );
  }

  getCourseMasterList<T>(
    loggedInUserId: string,
    examAgencyId: number,
    courseMasterID: string = ''
  ) {
    return this.httpClient.get<T>(
      `${this.BASE_URL}api/GetCourseMaster?LoggedInUserId=${loggedInUserId}&ExamAgencyId=${examAgencyId}&CourseMasterID=`
    );
  }
}
